export function buildRadiusPolygon(centerLon, centerLat, radiusMiles, points = 48) {
  const lon = Number(centerLon);
  const lat = Number(centerLat);
  const radius = Number(radiusMiles);
  if (!Number.isFinite(lon) || !Number.isFinite(lat) || !Number.isFinite(radius) || radius <= 0) return [];
  const angularDistance = radius / 3958.8;
  const latRadians = (lat * Math.PI) / 180;
  const lonRadians = (lon * Math.PI) / 180;
  const ring = [];
  for (let index = 0; index < points; index += 1) {
    const bearing = (index / points) * Math.PI * 2;
    const pointLat = Math.asin(
      Math.sin(latRadians) * Math.cos(angularDistance) +
      Math.cos(latRadians) * Math.sin(angularDistance) * Math.cos(bearing),
    );
    const pointLon = lonRadians + Math.atan2(
      Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(latRadians),
      Math.cos(angularDistance) - Math.sin(latRadians) * Math.sin(pointLat),
    );
    ring.push([(pointLon * 180) / Math.PI, (pointLat * 180) / Math.PI]);
  }
  return ring;
}
